import mattilsynet from './mattilsynet'
import snowchat from './snowchat'
import lab from './lab'
import visma from './visma'
import rusinfo from './rusinfo'
import felleskatalogen from './felleskatalogen'

const configs = {
  mattilsynet,
  rusinfo,
  snowchat,
  lab,
  visma,
  felleskatalogen,
}

export default configs
